import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noHtmlTagsValidator(control: AbstractControl): ValidationErrors | null {
  const nameRegExp = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/;
  if (!control.value) {
    return null;
  }
  const forbidden = control.value.toString().match(nameRegExp);
  return forbidden ? { noHtmlTags: true } : null;
}
